var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.contents.length
    ? _c("div", [
        _c("em", [_vm._v(_vm._s(_vm.processName(_vm.valueName)))]),
        _vm._v(" "),
        _c("span", [
          _c("table", { staticClass: "table table-striped" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.contents, function (elem) {
                return _c("tr", { key: elem.order }, [
                  _c("td", [
                    _vm._v(
                      "\n                " +
                        _vm._s(elem.value) +
                        "\n            "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n                " +
                        _vm._s(elem.meaning) +
                        "\n            "
                    ),
                  ]),
                ])
              }),
              0
            ),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { scope: "col" } }, [
          _vm._v("\n                Value\n            "),
        ]),
        _vm._v(" "),
        _c("th", { attrs: { scope: "col" } }, [
          _vm._v("\n                Meaning\n            "),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }